import styled from "styled-components";
import Title from "common/Typography/Title";
import { onboardingStyles } from "@shared/features/onboarding/styles";

export const PrimaryTitle = styled(Title)<{ $isMobile: boolean }>`
  ${onboardingStyles.primaryTitle};
`;

export const Wrapper = styled.div<{ $isMobile: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  ${(p) =>
    p.$isMobile &&
    `
  padding-bottom: 24px;
  `}
`;
